import type { RouteRecordRaw } from 'vue-router'

const RapidReviewPage = () =>
  import('../pages/rapid_review/components/RapidReviewPage.vue')
const DocumentsPage = () =>
  import('../pages/documents/components/DocumentsPage.vue')
const RequestsPage = () =>
  import('../pages/requests/components/RequestsPage.vue')
const RequestShowPage = () =>
  import('../pages/request_show/components/RequestShowPage.vue')
const DocumentDashboard = () =>
  import('../pages/admin/components/DocumentDashboard.vue')
const CreateRequestPage = () =>
  import('../pages/create_request/components/create_request.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/app/rapidreview/:prettyId',
    name: 'rapid-review',
    component: RapidReviewPage,
    props: true
  },
  {
    path: '/documents',
    name: 'all-documents',
    component: DocumentsPage,
    meta: {
      title: 'Documents'
    }
  },
  {
    path: '/requests/new/:slug?',
    name: 'new-request',
    component: CreateRequestPage,
    meta: {
      title: 'Make request',
      showFooter: true
    }
  },
  {
    path: '/admin/custom_fields_preview',
    name: 'custom-fields-preview',
    component: CreateRequestPage,
    meta: {
      title: '[PREVIEW] Make request',
      showFooter: true
    },
    props: { customFieldsPreview: true }
  },
  {
    path: '/admin/custom_fields_preview/:customFormId',
    name: 'custom-form-preview',
    component: CreateRequestPage,
    meta: {
      title: '[PREVIEW] Make request',
      showFooter: true
    },
    props: (route) => ({
      customFieldsPreview: true,
      customFormId: route.params.customFormId
    })
  },
  {
    path: '/requests',
    name: 'all-requests',
    component: RequestsPage,
    meta: {
      title: 'Requests'
    }
  },
  {
    path: '/requests/:prettyId',
    name: 'request-show',
    component: RequestShowPage,
    props: true,
    meta: {
      title: 'Request'
    }
  },
  {
    path: '/admin/document_dashboard',
    name: 'document-dashboard',
    component: DocumentDashboard,
    props: true,
    meta: {
      title: 'Document dashboard'
    }
  }
]

export default routes
